import script from "./WantToWorkCard.vue?vue&type=script&setup=true&lang=js"
export * from "./WantToWorkCard.vue?vue&type=script&setup=true&lang=js"

import "./WantToWorkCard.vue?vue&type=style&index=0&id=fe9574f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe9574f4"]])

export default __exports__